
// rounting
import BidProjectList from './bid-project-list/bid-project-list.vue';

export default [
  {
    path: 'list',
    name: 'BidProjectList',
    component: BidProjectList,
    meta: {
      title: '竞价大厅',
      breadCrumbShowIndexArr: [0]  // 面包屑
    }
  }
];
